<script>
import TopBar from '@/components/_layout/TopBar'

export default {
  components: {
    TopBar,
  },
}
</script>

<template>
  <div class="d-flex flex-column w-100 bg-light" style="">
    <div class="print-container container mx-auto">
      <!-- <top-bar class="pt-1 flex-shrink-0" :showUsers="false" :hideMenu="true" /> -->
      <div class="row content">
        <div class="col p-0">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.print-container {
  margin-top: 1rem;
  width: 90%;
  max-width: 100%;
  overflow: auto;
  background: var(--light-color);
}
@media print {
  .print-container {
    width: 100%;
    max-width: 100%;
    overflow: visible;
    width: 100% !important;
    border: 0 !important;
    margin: 0 !important;
  }
}
</style>
